"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _jsxRuntime = require("@emotion/react/jsx-runtime");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var SvgRocket = function SvgRocket(_ref) {
  var fill = _ref.fill,
      theme = _ref.theme,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["fill", "theme", "title"]);

  return (0, _jsxRuntime.jsxs)("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 32 32",
    fill: "none"
  }, props), {}, {
    children: [title ? (0, _jsxRuntime.jsx)("title", {
      children: title
    }) : null, (0, _jsxRuntime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M24.678 30.989c.905-.205 1.515-1.837 1.64-2.727.19-1.364.454-4.694.182-5.762a21.553 21.553 0 01-.158-.68c-.32-1.447-.66-2.988-2.897-4.49-.375-.25-.496-.514-.494-.94.01-2.318-.193-4.622-.667-6.896-.359-1.723-.951-3.307-1.975-4.832-3.42-5.097-5.88-4.687-8.657.076-.75 1.287-1.349 2.49-1.708 3.864-.683 2.617-.824 5.294-.913 7.975-.01.326-.122.525-.4.71-1.961 1.296-3.275 3.052-3.539 5.36-.142 1.24-.09 2.505-.04 3.762.01.213.018.425.026.638.03.837.177 1.675.329 2.502.128.698.478 1.297 1.265 1.44.788.142 3.03-1.908 4.328-3.547 0 0 1.38-2.46 4.659-2.46 2.05 0 3.28.306 4.92 2.46.536.704 3.23 3.744 4.099 3.547zM14.5 8A1.5 1.5 0 0013 9.5v6a1.5 1.5 0 003 0v-6A1.5 1.5 0 0014.5 8z",
      fill: "#27255F"
    }), (0, _jsxRuntime.jsx)("mask", {
      id: "rocket_svg__a",
      maskUnits: "userSpaceOnUse",
      x: 5,
      y: 1,
      width: 22,
      height: 30,
      children: (0, _jsxRuntime.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M24.678 30.989c.905-.205 1.515-1.837 1.64-2.727.19-1.364.454-4.694.182-5.762a21.553 21.553 0 01-.158-.68c-.32-1.447-.66-2.988-2.897-4.49-.375-.25-.496-.514-.494-.94.01-2.318-.193-4.622-.667-6.896-.359-1.723-.951-3.307-1.975-4.832-3.42-5.097-5.88-4.687-8.657.076-.75 1.287-1.349 2.49-1.708 3.864-.683 2.617-.824 5.294-.913 7.975-.01.326-.122.525-.4.71-1.961 1.296-3.275 3.052-3.539 5.36-.142 1.24-.09 2.505-.04 3.762.01.213.018.425.026.638.03.837.177 1.675.329 2.502.128.698.478 1.297 1.265 1.44.788.142 3.03-1.908 4.328-3.547 0 0 1.38-2.46 4.659-2.46 2.05 0 3.28.306 4.92 2.46.536.704 3.23 3.744 4.099 3.547zM14.5 8A1.5 1.5 0 0013 9.5v6a1.5 1.5 0 003 0v-6A1.5 1.5 0 0014.5 8z",
        fill: "#fff"
      })
    }), (0, _jsxRuntime.jsx)("g", {
      mask: "url(#rocket_svg__a)",
      children: (0, _jsxRuntime.jsx)("path", {
        fill: fill || theme.colors.primary.main,
        d: "M-59-59H90.747V91H-59z"
      })
    })]
  }));
};

var _default = SvgRocket;
exports["default"] = _default;